import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

import { ConfirmModalProps } from "../../types/interface";
import { BOOKING_STRINGS } from "../..//constants/strings";

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title,
  description,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Typography>{description}</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          {BOOKING_STRINGS.CANCEL}
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: "var(--danger)", // ✅ theme color
            textTransform: "none",
            "&:hover": {
              backgroundColor: "var(--danger)",
            },
          }}
        >
          {BOOKING_STRINGS.CONFIRM}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;